import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import Document from "./routes/Document";
export default store => ({
  path: "document",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "documents" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [Document(store)],
});
